import { ComponentPropsWithRef } from "react";
import RadioStyle from "./css/Radio.module.css";

type RadioProps = ComponentPropsWithRef<"input">;

function Radio({ ...props }: RadioProps) {
    return (
        <input
            className={RadioStyle.radio}
            type="radio"
            {...props}
        />
    )
}

export default Radio;